import { SearchPredicate } from '@nx-smartmonkey/shared/domain';
import { PaginatedResult } from '@nx-smartmonkey/shared/interfaces';

import { GeoFence } from '../../domain/geoFence/GeoFence';
import { FlatProject } from '../../domain/project/FlatProject';
import { Project } from '../../domain/project/Project';
import { ProjectUser } from '../../domain/project/ProjectUser';
import { Stop } from '../../domain/stop/Stop';
import { StopFlat } from '../../domain/stop/StopFlat';
import { VehicleFlat } from '../../domain/vehicle/VehicleFlat';
import { ProjectStopsTableColumn } from './tableColumns';

export enum ProjectActionType {
  SET_SEARCH_PROJECT_STOPS_PREDICATES = `SET_SEARCH_PROJECT_STOPS_PREDICATES`,
  FETCH_PROJECTS_SUCCESS = `FETCH_PROJECTS_SUCCESS`,
  SET_ACTIVE_PROJECT = `SET_ACTIVE_PROJECT`,
  PROJECTS_DELETE_PROJECT_SUCCESS = `PROJECTS_DELETE_PROJECT_SUCCESS`,
  PROJECTS_CREATE_PROJECT_SUCCESS = `PROJECTS_CREATE_PROJECT_SUCCESS`,
  PROJECTS_EDIT_PROJECTS_RESOURCES_SUCCESS = `PROJECTS_EDIT_PROJECTS_RESOURCES_SUCCESS`,
  SEARCH_STOPS_SUCCESS = `SEARCH_STOPS_SUCCESS`,
  SEARCH_FLAT_STOPS_SUCCESS = `SEARCH_FLAT_STOPS_SUCCESS`,
  SET_PROJECT_STOPS_TABLE_COLUMNS = `SET_PROJECT_STOPS_TABLE_COLUMNS`,
  SET_SELECTED_STOPS = `SET_SELECTED_STOPS`,
  SEARCH_FLAT_VEHICLES_SUCCESS = `SEARCH_FLAT_VEHICLES_SUCCESS`,
  ON_SELECT_STOP = `ON_SELECT_STOP`,
  RESET_PROJECT = `RESET_PROJECT`,
  FETCH_PROJECT_USERS_SUCCESS = `FETCH_PROJECT_USERS_SUCCESS`,
  FETCH_PROJECT_GEOFENCES_SUCCESS = `FETCH_PROJECT_GEOFENCES_SUCCESS`,
}

export interface SetSearchProjectStopsPredicatesAction {
  type: ProjectActionType.SET_SEARCH_PROJECT_STOPS_PREDICATES;
  payload: {
    predicates: Array<SearchPredicate>;
    predicatesBase64: string;
  };
}

export interface FetchProjectsSuccessAction {
  type: ProjectActionType.FETCH_PROJECTS_SUCCESS;
  payload: {
    flatProjects: FlatProject[];
  };
}

export interface SetActiveProjectAction {
  type: ProjectActionType.SET_ACTIVE_PROJECT;
  payload: {
    activeProject: Project;
  };
}

export interface ProjectsDeleteProjectSuccessAction {
  type: ProjectActionType.PROJECTS_DELETE_PROJECT_SUCCESS;
  payload: {
    projectId: string;
  };
}

export interface ProjectsCreateProjectSuccessAction {
  type: ProjectActionType.PROJECTS_CREATE_PROJECT_SUCCESS;
  payload: {
    project: Project;
  };
}

export interface ProjectsEditProjectsResourcesSuccessAction {
  type: ProjectActionType.PROJECTS_EDIT_PROJECTS_RESOURCES_SUCCESS;
  payload: {
    projects: Array<Project>;
  };
}

export interface SearchStopsSuccessAction {
  type: ProjectActionType.SEARCH_STOPS_SUCCESS;
  payload: {
    stopsPagination: PaginatedResult<Stop>;
  };
}

export interface SearchFlatStopsSuccessAction {
  type: ProjectActionType.SEARCH_FLAT_STOPS_SUCCESS;
  payload: {
    flatStops: Array<StopFlat>;
  };
}

export interface SetProjectStopsTableColumnsAction {
  type: ProjectActionType.SET_PROJECT_STOPS_TABLE_COLUMNS;
  payload: Array<ProjectStopsTableColumn>;
}

export interface SetSelectedStopsAction {
  type: ProjectActionType.SET_SELECTED_STOPS;
  payload: {
    selectedStops: Array<string>;
  };
}

export interface SearchFlatVehiclesSuccessAction {
  type: ProjectActionType.SEARCH_FLAT_VEHICLES_SUCCESS;
  payload: {
    flatVehicles: Array<VehicleFlat>;
  };
}

export interface OnSelectStopAction {
  type: ProjectActionType.ON_SELECT_STOP;
  payload: {
    stopId: string;
    withControlKey?: boolean;
  };
}

export interface FetchProjectUsersSuccessAction {
  type: ProjectActionType.FETCH_PROJECT_USERS_SUCCESS;
  payload: {
    users: Array<ProjectUser>;
  };
}

export interface FetchProjectGeofencesSuccessAction {
  type: ProjectActionType.FETCH_PROJECT_GEOFENCES_SUCCESS;
  payload: {
    geoFences: Array<GeoFence>;
  };
}

export interface ResetProjectAction {
  type: ProjectActionType.RESET_PROJECT;
}

export type ProjectActions =
  | SetSearchProjectStopsPredicatesAction
  | FetchProjectsSuccessAction
  | SetActiveProjectAction
  | ProjectsDeleteProjectSuccessAction
  | ProjectsCreateProjectSuccessAction
  | ProjectsEditProjectsResourcesSuccessAction
  | SearchStopsSuccessAction
  | SearchFlatStopsSuccessAction
  | SetProjectStopsTableColumnsAction
  | SetSelectedStopsAction
  | SearchFlatVehiclesSuccessAction
  | OnSelectStopAction
  | ResetProjectAction
  | FetchProjectUsersSuccessAction
  | FetchProjectGeofencesSuccessAction;
